import React from 'react';
import { Badge, Button, ListGroup } from 'react-bootstrap';

const dash = (value) => value ?? '-';

function Fact({ label, children }) {
    return (
        <div className="d-flex justify-content-between gap-3">
            <dt className="fw-normal text-muted">{label}</dt>
            <dd className="mb-0 text-end">{children}</dd>
        </div>
    );
}

/**
 * The budgets table as a stacked list for a phone: one item per program with
 * its figures as label and value pairs, a full-width Edit, and the totals last.
 */
function BudgetCards({ summaries, totals, programs, formatCurrency, onEdit }) {
    return (
        <ListGroup as="ul" variant="flush" aria-label="Budgets">
            {summaries.map((summary) => {
                const { budget } = summary;
                const info = programs[budget.program] || {};
                return (
                    <ListGroup.Item as="li" key={budget._id} className="px-0">
                        <div className="mb-2">
                            <Badge
                                className="admin-program-badge me-1"
                                data-program={budget.program}
                            >
                                {info.label || budget.program?.toUpperCase()}
                            </Badge>
                            <span className="fw-semibold">{info.full}</span>
                        </div>
                        <dl className="small mb-2">
                            <Fact label="Allocated positions">
                                {dash(budget.allocatedPositions)}
                            </Fact>
                            <Fact label="Pay rate">
                                {budget.payRate ? `$${budget.payRate}/hr` : '-'}
                            </Fact>
                            <Fact label="Hours per position">
                                {dash(budget.hoursPerPosition)}
                            </Fact>
                            <Fact label="Allocated amount">
                                {formatCurrency(budget.allocatedAmount)}
                            </Fact>
                            <Fact label="Offered">
                                {summary.offeredPositions ?? 0}
                            </Fact>
                            <Fact label="Accepted">
                                {summary.acceptedPositions ?? 0}
                            </Fact>
                            <Fact label="Remaining">
                                {dash(summary.remainingPositions)}
                            </Fact>
                        </dl>
                        <Button
                            variant="outline-primary"
                            className="w-100 admin-touch-target"
                            aria-label={`Edit ${info.full || budget.program} budget`}
                            onClick={() => onEdit(summary)}
                        >
                            Edit
                        </Button>
                    </ListGroup.Item>
                );
            })}
            {totals && (
                <ListGroup.Item as="li" className="px-0 fw-bold">
                    <div className="mb-2">Totals</div>
                    <dl className="small mb-0">
                        <Fact label="Allocated positions">
                            {dash(totals.allocatedPositions)}
                        </Fact>
                        <Fact label="Allocated amount">
                            {formatCurrency(totals.allocatedAmount)}
                        </Fact>
                        <Fact label="Offered">
                            {totals.offeredPositions ?? 0}
                        </Fact>
                        <Fact label="Accepted">
                            {totals.acceptedPositions ?? 0}
                        </Fact>
                        <Fact label="Remaining">
                            {dash(totals.remainingPositions)}
                        </Fact>
                    </dl>
                </ListGroup.Item>
            )}
        </ListGroup>
    );
}

export default BudgetCards;
